import React from 'react'
import { RawReferenceFallback } from './RawReferenceFallback'
import { ReferencePicker } from './ReferencePicker'
import { MeetingTemplateValueLabel, MeetingTemplateWidget } from './MeetingTemplateWidget'
import { optionLabelOf, useDocumentTypeOptions, useEmailTypeOptions } from './referenceOptionSources'
import { EMAIL_TYPE_KIND_BY_IPH_TYPE, resolveIphType } from './iphBindings'
import { type ReferenceValueLabelProps, type ZocksReferenceWidgetProps } from './registry'

type EmailIphType = keyof typeof EMAIL_TYPE_KIND_BY_IPH_TYPE

const EmailTypePicker: React.FC<ZocksReferenceWidgetProps & { iphType: EmailIphType }> = ({ iphType, ...props }) => {
  const { options, loading } = useEmailTypeOptions(iphType)
  return <ReferencePicker {...props} options={options} loading={loading} />
}

const DocumentTypePicker: React.FC<ZocksReferenceWidgetProps> = (props) => {
  const { options, loading } = useDocumentTypeOptions()
  return <ReferencePicker {...props} options={options} loading={loading} />
}

export const IphTemplateWidget: React.FC<ZocksReferenceWidgetProps> = (props) => {
  const resolved = resolveIphType(props.config)
  if (resolved.kind === 'unknown') {
    return <RawReferenceFallback {...props} reason={resolved.reason} />
  }
  if (resolved.kind === 'email') {
    return <EmailTypePicker {...props} iphType={resolved.iphType} />
  }
  return resolved.kind === 'meeting-template' ? <MeetingTemplateWidget {...props} /> : <DocumentTypePicker {...props} />
}

const EmailTypeValueLabel: React.FC<ReferenceValueLabelProps & { iphType: EmailIphType }> = ({ iphType, value, fallback }) => (
  <>{optionLabelOf(useEmailTypeOptions(iphType), value, fallback)}</>
)

const DocumentTypeValueLabel: React.FC<ReferenceValueLabelProps> = ({ value, fallback }) => <>{optionLabelOf(useDocumentTypeOptions(), value, fallback)}</>

export const IphTemplateValueLabel: React.FC<ReferenceValueLabelProps> = (props) => {
  const resolved = resolveIphType(props.config)
  if (resolved.kind === 'unknown') {
    return <>{props.fallback}</>
  }
  if (resolved.kind === 'email') {
    return <EmailTypeValueLabel {...props} iphType={resolved.iphType} />
  }
  return resolved.kind === 'meeting-template' ? <MeetingTemplateValueLabel {...props} /> : <DocumentTypeValueLabel {...props} />
}
